<template>
  <div class="from-the-blog">
    <div class="from-the-blog__date" v-if="blogPage">
      <span>From The Blog {{ date }}</span>
    </div>

    <sc-text
      class="from-the-blog__title"
      v-if="blogPage && blogPage.fields && blogPage.fields.resourceTitle"
      :field="blogPage.fields.resourceTitle"
    />
    <a v-if="blogPage && blogPage.url" class="c-cta--tertiary" :href="blogPage.url"
      >Read More <span class="sr-only">{{ blogPage?.fields?.resourceTitle?.value }}</span></a
    >
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-From-The-Blog',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  computed: {
    blogPage() {
      return this?.fields?.blogPage;
    },
    date() {
      return this?.fields?.blogPage?.fields?.publishedAt?.value
        ? this.convertToDate(this?.fields?.blogPage?.fields?.publishedAt?.value)
        : '';
    }
  },
  methods: {
    convertToDate(timestamp) {
      const date = new Date(timestamp);
      // use 2-digits for month and day, and use UTC so it isn't adjusted to local timezone, which can change the shown date
      const dateOptions = {
        weekday: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
      };
      // Use replace function for separator to be a dot instead of slash or dash
      return date?.toLocaleDateString(undefined, dateOptions)?.replace(/[^0-9]/g, '.');
    }
  }
};
</script>

<style lang="scss" scoped>
.from-the-blog {
  &:deep() {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
    position: relative;
    background-color: $white;
    padding: 2rem 2rem 1rem;
    border-top: solid 0.4rem $orange;
    box-shadow: 0 0.3rem 0.7rem 0 rgb(0 0 0 / 12%), 0 1.8rem 1.7rem 0 rgb(0 0 0 / 12%);

    .from-the-blog__date {
      @include font-styles('Arial Narrow', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
      text-transform: uppercase;

      span {
        display: block;
        padding-right: 0.5rem;
        margin-bottom: 1rem;
      }
    }

    .from-the-blog__title {
      display: block;
      @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);
      margin-bottom: 0.5rem;
    }

    .c-cta--tertiary {
      margin: 0;
      padding-left: 0;
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, 0, $blue);

      &:hover {
        &:after {
          left: 1rem;
        }
      }
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
  }
}
</style>
